export const SNAP_DISTANCE = 20;
